import { render, staticRenderFns } from "./CloseOctagon.vue?vue&type=template&id=c8a42696"
import script from "./CloseOctagon.vue?vue&type=script&lang=js"
export * from "./CloseOctagon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports